import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton.jsx";

export const Statement = ({ onAnswer }) => {
    const [showFirstLine, setShowFirstLine] = useState(false);
    const [showSecondLine, setShowSecondLine] = useState(false);
    const [showReviews, setShowReviews] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    const [currentReviewIndex, setCurrentReviewIndex] = useState(0);

    const reviews = [
        { 
            source: "Google", 
            icon: "🔍", 
            text: "Dedicated <span class='font-bold text-green-600'>gluten-free kitchen</span> with amazing safety protocols!", 
            rating: "⭐⭐⭐⭐⭐",
            relevant: true 
        },
        { 
            source: "Yelp", 
            icon: "📱", 
            text: "The regular <span class='font-bold text-red-600'>wheat bread</span> is to die for!", 
            rating: "⭐⭐⭐⭐",
            relevant: false 
        },
        { 
            source: "Maps", 
            icon: "📍", 
            text: "Staff is trained on <span class='font-bold text-green-600'>celiac safety</span> - very knowledgeable", 
            rating: "⭐⭐⭐⭐⭐",
            relevant: true 
        },
        { 
            source: "TripAdvisor", 
            icon: "✈️", 
            text: "Their <span class='font-bold text-red-600'>wheat pasta</span> is the best in town", 
            rating: "⭐⭐⭐⭐",
            relevant: false 
        },
        { 
            source: "Google", 
            icon: "🔍", 
            text: "Separate <span class='font-bold text-green-600'>gluten-free prep</span> area for items!", 
            rating: "⭐⭐⭐⭐⭐",
            relevant: true 
        },
        { 
            source: "Yelp", 
            icon: "📱", 
            text: "The beer selection is amazing, all craft <span class='font-bold text-red-600'>wheat beer</span>", 
            rating: "⭐⭐⭐⭐",
            relevant: false 
        },
        { 
            source: "Maps", 
            icon: "📍", 
            text: "<span class='font-bold text-green-600'>gluten-free</span> certified - <span class='font-bold text-green-600'>celiac safe</span>!", 
            rating: "⭐⭐⭐⭐⭐",
            relevant: true 
        },
        { 
            source: "TripAdvisor", 
            icon: "✈️", 
            text: "The fresh baked <span class='font-bold text-red-600'>croissants</span> are flaky perfection", 
            rating: "⭐⭐⭐⭐",
            relevant: false 
        },
        { 
            source: "Google", 
            icon: "🔍", 
            text: "They use <span class='font-bold text-green-600'>Nima sensor</span> to test for <span class='font-bold text-green-600'>gluten-free</span>!", 
            rating: "⭐⭐⭐⭐⭐",
            relevant: true 
        },
        { 
            source: "Yelp", 
            icon: "📱", 
            text: "Great ramen with authentic <span class='font-bold text-red-600'>wheat noodles</span>", 
            rating: "⭐⭐⭐⭐",
            relevant: false 
        }
    ];

    useEffect(() => {
        setTimeout(() => setShowFirstLine(true), 200);
        setTimeout(() => setShowSecondLine(true), 600);
        setTimeout(() => setShowReviews(true), 1000);
        setTimeout(() => setShowButton(true), 2000);
    }, []);

    useEffect(() => {
        if (showReviews) {
            const interval = setInterval(() => {
                setCurrentReviewIndex((prevIndex) => (prevIndex + 1) % reviews.length);
            }, 3000);
            return () => clearInterval(interval);
        }
    }, [showReviews]);

    const handleContinue = () => {
        setIsExiting(true);
        setTimeout(() => onAnswer('continue'), 500);
    };

    return (
        <div
            className={classNames(
                "relative h-full flex flex-col items-center justify-start px-6",
                isExiting ? "opacity-0 transition-opacity duration-500" : "opacity-100 transition-opacity duration-500"
            )}
        >
            <div className="text-center space-y-4 max-w-[600px] mt-[48px]">
                <div className="overflow-hidden">
                    <h2
                        className={classNames(
                            "text-[32px] md:text-[40px] leading-tight font-bold transition-all duration-500 text-black",
                            showFirstLine ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        All your reviews in{' '}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            one place
                        </span>
                    </h2>
                </div>
                
                <div className="overflow-hidden">
                    <h3
                        className={classNames(
                            "text-xl md:text-2xl text-gray-600 transition-all duration-500",
                            showSecondLine ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        We aggregate reviews from trusted sources to focus on what matters to you
                    </h3>
                </div>
            </div>

            {showReviews && (
                <div className="mt-8 mb-12">
                    <div className="relative w-full h-64 flex items-center justify-center">
                        {reviews.map((review, index) => (
                            <div
                                key={index}
                                className={classNames(
                                    "absolute transition-opacity duration-1000",
                                    currentReviewIndex === index ? "opacity-100" : "opacity-0"
                                )}
                            >
                                <div className="bg-white rounded-xl p-4 shadow-lg border border-gray-100 w-72 relative">
                                    <div className={classNames(
                                        "absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center",
                                        review.relevant ? "bg-green-500" : "bg-red-500"
                                    )}>
                                        {review.relevant ? (
                                            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                        ) : (
                                            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        )}
                                    </div>
                                    
                                    <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-2">
                                            <span className="text-2xl">{review.icon}</span>
                                            <span className="font-medium text-gray-700">{review.source}</span>
                                        </div>
                                    </div>
                                    <p 
                                        className="text-gray-600 mb-2 line-clamp-2 min-h-[40px]"
                                        dangerouslySetInnerHTML={{ __html: review.text }}
                                    />
                                    <div className="text-sm">{review.rating}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 transition-all duration-500 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>
        </div>
    );
};

export default Statement; 